<template>
  <div>
    <div id="email-editor" :style="basicStyle"></div>
  </div>
</template>

<script>
  import 'iframe-resizer/js/iframeResizer.contentWindow'
  import EditorJs from '@editorjs/editorjs'
  import Header from '@editorjs/header'
  import '@/assets/scss/iframe.scss'

  export default {
    data () {
      const eventId = this.$route.params.id
      return {
        eventId,
        editor: null,
        body: null,
        target: 'ticketEmailBody'
      }
    },
    created () {
      this.listen()
    },
    computed: {
      basicStyle () {
        return {
          'font-family': 'Arial'
        }
      },
      type () { return this.$route.params.type }
    },
    methods: {
      listen () {
        const inIframe = window.self !== window.top
        const that = this

        if (inIframe) window.iFrameResizer = {
          onMessage (msg) {
            switch (msg.type) {
              case 'init':
                that.initEditor(msg.data)
                break
              case 'trigger-save':
                that.changing(true)
                break
              default:
                break

            }
          }
        }
      },
      initEditor (body) {
        if (this.editor !== null) return
        this.body = body
        this.editor = new EditorJs({
          holder: 'email-editor',
          tools: {
            header: Header,
          },
          data: this.body,
          onChange: this.changing
        })

      },
      changing (isHurry) {
        if (this.editor === null) return
        this.editor.save()
          .then(res => {
            if (window.parentIFrame === undefined) return Promise.reject('no parent')
            window.parentIFrame.sendMessage({
              type: isHurry ? 'save-hurry' : 'save',
              data: res
            })
          })
          .catch(err => void err)
      },
    },
    beforeDestroy () {
      if (this.editor !== null) this.editor.destroy()
    }
  }
</script>